import type { NavItem } from "../types/domain";

export const storefrontNav: NavItem[] = [
  { label: "Trang chủ", href: "/" },
  { label: "Danh mục", href: "/category/phu-tung-xe-dien" },
  { label: "Tìm kiếm", href: "/search" },
  { label: "Hỏi là có", href: "/ask" },
  { label: "B2B / Đại lý", href: "/b2b" },
  { label: "Thương hiệu", href: "/brands" },
  { label: "Blog kỹ thuật", href: "/blog" },
  { label: "Liên hệ", href: "/contact" }
];

export const accountNav: NavItem[] = [
  { label: "Tổng quan", href: "/account" },
  { label: "Đơn hàng", href: "/account/orders" },
  { label: "Địa chỉ", href: "/account/addresses" },
  { label: "Yêu thích", href: "/account/wishlist" },
  { label: "Bảo hành", href: "/account/warranty" },
  { label: "Hỏi là có", href: "/account/ask" },
  { label: "Thông báo", href: "/account/notifications" },
  { label: "Hồ sơ", href: "/account/profile" },
  { label: "Bảo mật", href: "/account/security" }
];

export const adminNav: NavItem[] = [
  { label: "Tổng quan", href: "/admin" },
  { label: "Đơn hàng", href: "/admin/orders" },
  { label: "Sản phẩm", href: "/admin/products" },
  { label: "Kho hàng", href: "/admin/inventory" },
  { label: "Nhập hàng", href: "/admin/purchasing" },
  { label: "Nhà cung cấp", href: "/admin/suppliers" },
  { label: "Khách hàng", href: "/admin/customers" },
  { label: "B2B / Đại lý", href: "/admin/b2b" },
  { label: "Marketplace", href: "/admin/marketplaces" },
  { label: "Chat", href: "/admin/chat" },
  { label: "Tài chính", href: "/admin/finance" },
  { label: "Đối soát", href: "/admin/reconciliation" },
  { label: "Báo cáo", href: "/admin/reports" },
  { label: "Bảo hành / Trả hàng", href: "/admin/returns" },
  { label: "Thành viên", href: "/admin/members" },
  { label: "Vai trò", href: "/admin/roles" },
  { label: "Audit", href: "/admin/audit" },
  { label: "Cài đặt", href: "/admin/settings" }
];

export const categoryGroups = [
  { title: "Xe điện", description: "Pin, sạc, controller, tay ga, phanh" },
  { title: "Xe máy", description: "Bố thắng, nhông sên, bugi, lọc gió" },
  { title: "Ô tô điện", description: "Cảm biến, cầu chì, phụ kiện sạc" },
  { title: "Dầu nhớt", description: "Nhớt máy, láp, dung dịch bảo dưỡng" },
  { title: "Phụ kiện", description: "Mũ, áo mưa, khóa, camera hành trình" },
  { title: "Hỏi là có", description: "Sourcing phụ tùng khó tìm" }
];
